import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SectionLabel } from './SectionCard';

const BLACK_FAMILY = 'CircularStdBlack, Helvetica, Arial, sans-serif';

interface Props {
  isSharePage?: boolean;
  onRetry: () => void;
}

/** In-app not-found state — replaces the old hard reload to /404. */
const ProfileNotFound: FC<Props> = ({ isSharePage, onRetry }) => {
  const navigate = useNavigate();
  return (
    <Box className="flex justify-center px-[24px] py-10 sm:py-16">
      <Box
        className="w-full max-w-[460px] bg-surface border border-border-token rounded-xl p-8 flex flex-col gap-3"
        style={{ boxShadow: 'var(--sh-2)' }}
      >
        <SectionLabel muted>Expert profile</SectionLabel>
        <Typography
          sx={{
            fontFamily: BLACK_FAMILY,
            fontSize: 24,
            lineHeight: 1.15,
            letterSpacing: '-.02em',
            color: 'var(--text)',
          }}
        >
          Expert not found.
        </Typography>
        <Typography sx={{ fontSize: 14.5, lineHeight: 1.6, color: 'var(--text-2)' }}>
          This profile may have been removed, or the link you followed is out of date.
        </Typography>
        <Box className="flex gap-2.5 mt-1.5">
          <button
            type="button"
            className="bg-accent text-rail font-bold text-[13px] rounded-xl px-4 py-3 hover:opacity-90"
            onClick={() => navigate(isSharePage ? '/experts/share' : '/experts')}
          >
            Back to experts
          </button>
          <button
            type="button"
            className="bg-surface border border-border-token text-text-1 font-bold text-[13px] rounded-xl px-4 py-3 hover:bg-surface-2"
            onClick={onRetry}
          >
            Try again
          </button>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileNotFound;
